import Logger from "./Logger";
import g from "./globals";
// import cookies from "./cookies";

const logger = new Logger(__filename);

const selectById = el => document.getElementById(el);

const removeClass = (el, className) => {
  if (!className || !el) {
    return;
  }
  logger.warn(className);
  if (el.classList) {
    el.classList.remove(className);
  } else {
    el.className = el.className.replace(new RegExp(`(^|\\b)${className.split(" ").join("|")}(\\b|$)`, "gi"), " ");
  }
};

const addClass = (el, className) => {
  if (!className || !el) {
    return;
  }
  if (el.classList) {
    el.classList.add(className);
  } else {
    el.className += ` ${className}`;
  }
};

const includes = (el, className) => {
  if (el && className) {
    return el.className.includes(className);
  }
  return false;
};

const buildSelector = (...categoryIds) => {
  const selectors = categoryIds.map(categoryId => {
    switch (true) {
      case g.channels.desktop:
        return `._category-link-wrapper[data-categoryid='${categoryId}']`;
      case g.channels.mobile:
        return `.menu-item[data-id='${categoryId}']`;
      default:
        return logger.warn("[[Channel not implemented]]");
    }
  });
  return selectors.join(",");
};

const bodyClassHandler = () => {
  const addedClasses = new Set();
  // const enabled = cookies.read("bodyClasses");

  // if (!enabled) {
  //   const restoreBodyClases = () => {
  //     addedClasses.forEach(c => {
  //       if (!document.body.classList.contains(c)) {
  //         document.body.classList.add(c);
  //       }
  //     });
  //   };

  //   window.addEventListener("resize", restoreBodyClases);
  //   window.addEventListener("orientationchange", restoreBodyClases);
  // }

  return {
    addBodyClass(classes) {
      if (classes) {
        if (Array.isArray(classes)) {
          classes.forEach(c => {
            if (!document.body.classList.contains(c)) {
              document.body.classList.add(c);
              addedClasses.add(c);
            }
          });
        } else {
          if (!document.body.classList.contains(classes)) {
            document.body.classList.add(classes);
            addedClasses.add(classes);
          }
        }
      }
    },
    removeBodyClass(classes) {
      if (classes) {
        if (Array.isArray(classes)) {
          classes.forEach(c => {
            if (document.body.classList.contains(c)) {
              document.body.classList.remove(c);
              addedClasses.delete(c);
            }
          });
        } else {
          if (document.body.classList.contains(classes)) {
            document.body.classList.remove(classes);
            addedClasses.delete(classes);
          }
        }
      }
    },
    flushBodyClasses() {
      addedClasses.forEach(this.removeBodyClass);
      addedClasses.clear();
    },
  };
};

const { addBodyClass, removeBodyClass, flushBodyClasses } = bodyClassHandler();

export default {
  removeClass,
  addClass,
  selectById,
  buildSelector,
  includes,
  addBodyClass,
  removeBodyClass,
  flushBodyClasses,
};
